import React from 'react';
import I18n from '@utils/i18n';
import { Checkbox } from '@ui/molecules/inputs';
import './SearchPanel.scss';
/* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
const t = (key, options) => String(I18n.t(key, options));
const CHECKBOX_ID = 'material-search-name-only';
export function SearchPanel({ nameOnly, onNameOnlyChange, totalCount, loading = false, popupRef, scrollRef, children }) {
    const scope = t(nameOnly ? 'material_search.summary.name_only' : 'material_search.summary.all_fields');
    const summary = `${t('material_search.summary.results', { count: totalCount })}${t('material_search.summary.separator')}${scope}`;
    return (React.createElement("div", { className: "qmb-popup material-search-panel", ref: popupRef },
        React.createElement("div", { className: "material-search-panel__header" },
            React.createElement(Checkbox, { id: CHECKBOX_ID, checked: nameOnly, onChange: onNameOnlyChange, label: t('material_search.name_only_label') }),
            React.createElement("small", { className: "material-search-panel__summary", "aria-live": "polite", "aria-busy": loading }, summary)),
        React.createElement("div", { className: "material-search-panel__scroll", ref: scrollRef }, children)));
}
